function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable eqeqeq */
import { promisify } from "./_utils/promisify";
import { styleIn } from "./_utils/styleOptions";

/**
 * actionsheet返回值格式化
 * @param res
 */
var formatResponse = function formatResponse(res) {
  return {
    text: res.data != undefined ? res.data : res.text
  };
};
/**
 * actionsheet参数格式化
 * @param options
 */


function styleOptions(options) {
  return options ? _extends({}, options, {
    success: function success(res) {
      options.success && options.success(formatResponse(res));
    }
  }) : {};
}

export function normalizeGet(api, containerName) {
  return function (args) {
    return promisify(api)(styleOptions(styleIn(args, containerName))).then(formatResponse);
  };
}
export function normalizeSet(api, containerName) {
  return function (args) {
    return promisify(api)(styleIn(args, containerName));
  };
}